// import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const { 
    REACT_APP_BASE_URL_GIS_SERVER } = window['runConfig'];

export const getToken = () => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/portal/sharing/rest/generateToken`;

            const bodyFormData_getToken = new FormData();
            bodyFormData_getToken.set('f', 'json')
            bodyFormData_getToken.append('username', 'portaladmin');
            bodyFormData_getToken.append('password', 'Intelli2020');
            bodyFormData_getToken.append('referer', 'https://gis.i-aksb.com.my/server/admin');
            bodyFormData_getToken.append('expires', '1200');

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getToken,
            })

        });

    return res;
}


